module.exports = __webpack_public_path__ + "static/img/t1.42ee13d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/technology/t1.jpg
// module id = hXmb
// module chunks = 0